import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { DefaultLayout } from "@components/Layouts";
import { url_reverse } from "@components/Utils";

function PocketsInfoEdit() {
    const { t } = useTranslation();
    const { slug, locale } = useParams();
    const navigate = useNavigate();

    const api_url = locale
        ? url_reverse("api:pockets:edit_info_locale", { slug, locale })
        : url_reverse("api:pockets:edit_info", { slug });

    const { apiData, setApiData } = useAppApi(api_url);
    const { pocket } = apiData || {};

    const backUrl = url_reverse("admin:pockets:items", {
        slug: pocket?.slug,
    });

    const header = (
        <>
            <Link to={`${url_reverse("admin:pockets:list")}#group_${pocket?.pocket_group_id}`}>{t("Карман")}</Link> –{" "}
            <Link to={backUrl}>{pocket?.name || ""}</Link>
        </>
    );

    const headerTools = (
        <>
            <ul className="nav nav-tabs">
                <li className="nav-item">
                    <Link
                        className={locale ? `nav-link` : `nav-link active`}
                        to={url_reverse("admin:pockets:edit_info", { slug })}
                    >
                        RU
                    </Link>
                </li>
                {apiData?.locales &&
                    apiData?.locales.map((loc, index) => (
                        <li key={`${loc}_${index}`} className="nav-item">
                            <Link
                                to={url_reverse("admin:pockets:edit_info_locale", { slug, locale: loc })}
                                className={locale === loc ? "nav-link active" : "nav-link"}
                            >
                                {loc.substring(0, 2).toUpperCase()}
                            </Link>
                        </li>
                    ))}
            </ul>
        </>
    );

    if (!apiData) return;

    return (
        <Card>
            <Card.Header className="p-0">
                <div className="dmg-card-header-title">{header}</div>
                <div className="dmg-card-header-tools">{headerTools}</div>
            </Card.Header>
            <Card.Body>
                <RenderForm
                    apiData={apiData}
                    setApiData={setApiData}
                    prefix="info"
                    afterRespOK={() => {
                        navigate(backUrl);
                    }}
                />
            </Card.Body>
        </Card>
    );
}

export default function PocketsInfoEditScreen() {
    return (
        <DefaultLayout>
            <PocketsInfoEdit />
        </DefaultLayout>
    );
}
